export const MonthUtil = {
   convertMonthYear(month_year) {
     let splitData = month_year.split('-');
     let month = parseInt(splitData[0], 10);
     let year = splitData[1];
     let yearBudd = parseInt(year, 10) + 543
     let monthName = ''
     switch (month) {
       case 1: monthName = 'มกราคม'; break;
       case 2: monthName = 'กุมภาพันธ์'; break;
       case 3: monthName = 'มีนาคม'; break;
       case 4: monthName = 'เมษายน'; break;
       case 5: monthName = 'พฤษภาคม'; break;
       case 6: monthName = 'มิถุนายน'; break;
       case 7: monthName = 'กรกฎาคม'; break;
       case 8: monthName = 'สิงหาคม'; break;
       case 9: monthName = 'กันยายน'; break;
       case 10: monthName = 'ตุลาคม'; break;
       case 11: monthName = 'พฤศจิกายน'; break;
       case 12: monthName = 'ธันวาคม'; break;
       default:
         monthName = ''
     }

     return monthName+' '+yearBudd
   }
}
